import {StickyNavigationMenuItemIconDefaultBox} from "./sticky-navigation-menu-item-icon.default.box";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

export const StickyNavigationMenuItemIconBox = styledByTheme(StickyNavigationMenuItemIconDefaultBox).apply();
